import React from 'react';

export default function PlayBigIcon() {
  return (
    <svg
      width="81px"
      height="81px"
      viewBox="0 0 81 81"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Play boton</title>
      <g
        id="Video-UI-Simple-Player-desktop"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        fillOpacity="0.9"
      >
        <g id='MacBook-Pro-16"-click-to-play' transform="translate(-511, -408)">
          <g id="Play-boton" transform="translate(511.6363, 408.1236)">
            <circle
              id="Oval"
              strokeOpacity="0.809351781"
              stroke="#FFFFFF"
              strokeWidth="5"
              fill="#14B395"
              cx="40"
              cy="40"
              r="37.5"
            ></circle>
            <path
              d="M46.4128824,23.5955411 C47.0493831,23.530592 47.710661,23.7084598 48.245849,24.144539 C48.3773503,24.2516882 48.497605,24.3719428 48.6047541,24.5034441 L71.6238486,52.754151 C72.0599278,53.289339 72.2377956,53.9506169 72.1728465,54.5871176 C72.1078975,55.2236182 71.8001316,55.8353416 71.2649435,56.2714208 C70.818895,56.6348678 70.2611333,56.8333333 69.6857612,56.8333333 L23.6475722,56.8333333 C22.9572162,56.8333333 22.3322162,56.5535113 21.8798052,56.1011003 C21.4273942,55.6486893 21.1475722,55.0236893 21.1475722,54.3333333 C21.1475722,53.7579612 21.3460377,53.2001995 21.7094847,52.754151 L44.7285792,24.5034441 C45.1646584,23.968256 45.7763818,23.6604901 46.4128824,23.5955411 Z"
              id="Triangle"
              stroke="#979797"
              fill="#FFFFFF"
              transform="translate(46.6667, 39.3333) rotate(90) translate(-46.6667, -39.3333)"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}
